// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fu-0";
export var headerCellHover = "_fu-1";
export var readCellContainer = "_fu-2";
export var searchHighlight = "_fu-4";
export var unreadIndicator = "_fu-3";